import styled, { css } from 'styled-components';

const thumbStyles = css`
  width: 14px;
  height: 14px;
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary500};
  box-shadow: none;
  cursor: pointer;
`;

const verticalWrapperStyles = css`
  width: 20px;
  height: ${({ $length }) => `${$length}px`};
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 20px;

  ${({ $orientation }) => $orientation === 'vertical' && verticalWrapperStyles}
`;

export const Input = styled.input`
  appearance: none;
  width: 100%;
  height: 4px;
  margin: 0;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.semantic.border.subtle};
  outline: none;

  ${({ $orientation, $length }) =>
    $orientation === 'vertical' &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      width: ${$length}px;
      transform: translate(-50%, -50%) rotate(-90deg);
      transform-origin: center;
    `}

  &:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.semantic.action.primary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &::-webkit-slider-runnable-track {
    height: 4px;
    border-radius: 999px;
    background: ${({ theme }) => theme.colors.semantic.border.subtle};
  }

  &::-moz-range-track {
    height: 4px;
    border-radius: 999px;
    background: ${({ theme }) => theme.colors.semantic.border.subtle};
  }

  &::-webkit-slider-thumb {
    ${thumbStyles}
    appearance: none;
    margin-top: -5px;
  }

  &::-moz-range-thumb {
    ${thumbStyles}
  }
`;
